module.exports = __webpack_public_path__ + "img/voice.b529cb08.svg";